import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSparkles } from '@fortawesome/pro-solid-svg-icons'
import { useTranslationRankmi } from 'helpers/translations.helper'
import {
  BlockButtonIconCircle,
  BlockButtonRoot,
} from './AiEvaluationBlockButton.styled'

interface Props {
  onClick: () => void
  disabled?: boolean
}

export const AiEvaluationBlockButton: React.FC<Props> = ({
  onClick,
  disabled,
}) => {
  const t = useTranslationRankmi({
    prefix: 'administration.blocks.aiEvaluation',
  })

  return (
    <BlockButtonRoot
      role="button"
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled}
      $disabled={disabled}
      onClick={() => !disabled && onClick()}
      onKeyDown={(e) => {
        if (disabled) return
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
    >
      <BlockButtonIconCircle $disabled={disabled}>
        <FontAwesomeIcon icon={faSparkles} />
      </BlockButtonIconCircle>
      {t('blockPickerLabel')}
    </BlockButtonRoot>
  )
}

export default AiEvaluationBlockButton
